export const STARTER_CHIPS_CSS = /* css */ `
  /* ── Starter chips (empty chat) ── */
  .lk-widget-starter-chips {
    display: flex; flex-wrap: wrap; gap: 8px;
    padding: 8px 15px 7px;
  }
  /* Line the chips up under the agent bubbles: avatar (34px) + row gap (10px). */
  .lk-widget-starter-chips--indented { padding-left: 59px; }
  .lk-widget-starter-chip {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 7px 12px; min-height: 34px;
    background: #fff; color: var(--wg-card-fg);
    border: 1px solid var(--wg-accent); border-radius: 9999px;
    font-family: inherit; font-size: 13px; font-weight: 500; line-height: 1.3;
    letter-spacing: 0.13px;
    cursor: pointer;
    transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
  }
  .lk-widget-starter-chip:hover { background: var(--wg-msg-bubble-agent); box-shadow: 0 0 10px rgba(10,70,40,0.15); }
  .lk-widget-starter-chip:active { transform: scale(0.97); }
  .lk-widget-starter-chip svg { flex-shrink: 0; color: var(--wg-clay); }
`;
